import { observer } from "mobx-react";
import React from "react";
import { Modal, Stack, Text } from "@mantine/core";
import { Cubby } from "../../stores/Cubby";
import { JsonView, allExpanded, darkStyles } from "react-json-view-lite";
import "react-json-view-lite/dist/index.css";
import {
  MODAL_WIDTH_FOR_DATA_INTENSIVE_MODALS,
  MODALS,
} from "../../helpers/constants";
import { TextWithInfoAndIcon } from "../dataDisplay/textWithInfoAndIcon";
import { ARTICLES } from "../../docs/docsIndex";
import { IconArrowBigUpFilled } from "@tabler/icons-react";
import { cleanNullsAndSort } from "../../helpers/sort";

const BitcoinWithdrawalEvents = observer(({ cubby }: { cubby: Cubby }) => {
  return (
    <>
      <Modal
        size={MODAL_WIDTH_FOR_DATA_INTENSIVE_MODALS}
        opened={cubby.currentModal === MODALS.BITCOIN_WITHDRAWAL_EVENTS}
        onClose={() => cubby.setModal(null)}
        title={
          <TextWithInfoAndIcon
            text="Bitcoin Withdrawals"
            articleSlug={ARTICLES.BITCOIN_WITHDRAWALS.slug}
            icon={<IconArrowBigUpFilled size={24} />}
            cubby={cubby}
            textSize="lg"
          />
        }
      >
        <Stack>
          {/* Map over cubby.payOffchainEvents.data and display each event in JsonView */}
          {cubby.onchainPaymentSuccesses.data?.map((event, index) => (
            <div key={index}>
              <JsonView
                data={cleanNullsAndSort(event)}
                shouldExpandNode={allExpanded}
                style={darkStyles}
              />
            </div>
          ))}
        </Stack>
      </Modal>
    </>
  );
});

export default BitcoinWithdrawalEvents;
